

  import Vue from 'vue';

  import navbar from '@/components/navbar.vue';
  import { mdbCardImage, mdbCardText, mdbModal, mdbModalHeader, mdbModalTitle, mdbModalBody, mdbModalFooter, mdbContainer, mdbCard, mdbBtn, mdbRow, mdbCol, mdbCardUp, mdbCardAvatar, mdbCardBody, mdbCardTitle, mdbIcon, mdbInput, mdbTbl, mdbTblBody, mdbTblHead } from 'mdbvue';
  import router from '../router';

  import store from '../store';

  export default Vue.extend({
    name: 'Result',
    data: function() {
      return {
        cities: store.state.cities, 
        name: store.state.name,
        isFromHistory: this.$route.query.historyChosenCity ? true : false,
        accuweatherError: false
      }
    },
    methods: {
      finalChosenCity: function() {
        if ( this.$route.query.historyChosenCity && typeof this.$route.query.historyChosenCity == 'string' ) {
          return parseInt(this.$route.query.historyChosenCity);
        }
        return store.state.finalChosenCity;
      },
      goToHome: function() {
        if ( this.isFromHistory ) {
          router.push('/history');
          return;
        }
        store.commit('STORE_RESULT', {
            chosenCity: this.finalChosenCity(),
            time: new Date(),
            name: this.name
          });
          router.push('/');
      }
    },
    mounted: function() {
        Promise.all([
          this.$store.dispatch('initFlights'),
          this.$store.dispatch('initWeather')
        ]).then(() => {
          // console.log('Flights init');
        })
        .catch(err => {
          this.accuweatherError = true;
          console.log('ERROR', err);
        });
    },
    components: {
      mdbContainer,
      navbar,
      mdbCard, 
      mdbBtn,
      mdbRow,
      mdbCol,
      mdbCardUp, 
      mdbCardAvatar, 
      mdbCardBody, 
      mdbCardTitle, 
      mdbIcon,
      mdbInput,
      mdbModal, 
      mdbModalHeader, 
      mdbModalTitle,
      mdbModalBody, 
      mdbModalFooter,
      mdbCardImage,
      mdbCardText,
      mdbTbl,
      mdbTblBody,
      mdbTblHead
    },
  });

